import { default as _u } from 'underscore';
import isAllowedTariffForUser from './isAllowedTariffForUser';
import getProductWithAppliedAccount from '../mutators/getProductWithAppliedAccount';
import getBillingUnitsCount from './getBillingUnitsCount';

export default (product, tariffs, tariffsAll, currentTariff, mainProduct, cart, priceEqGr) => {
    let result = null;
    product = getProductWithAppliedAccount(product, cart?.account_id);
    mainProduct = getProductWithAppliedAccount(product, cart?.account_id);
    currentTariff = currentTariff ?? product?.tariff ?? tariffsAll[product?.current_tariff_id];
    if (product?.product_id && currentTariff) {
        const sortedTariffs = Object.values(tariffs)
            .filter(tariff => isAllowedTariffForUser({ tariff, product, mainProduct, cart, atLeastOnePeriod: true }))
            .sort((a, b) => {
                if (priceEqGr) {
                    return a?.cost - b?.cost;
                } else {
                    return getBillingUnitsCount(
                        { tariff: a, product_id: product.product_id },
                        cart
                    ) - getBillingUnitsCount(
                        { tariff: b, product_id: product.product_id },
                        cart
                    );
                }
            });
        result = _u.find(sortedTariffs, (tariff) => getBillingUnitsCount(
            { tariff: currentTariff, product_id: product.product_id },
            cart
        ) <= getBillingUnitsCount(
            { tariff: tariff, product_id: product.product_id },
            cart
        ));
    }
    return result;
}
